import {
  Button,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Menu,
  Modal,
  Row,
  Tag,
} from 'antd';
import styled from 'styled-components';

const CheckboxGroup = Checkbox.Group;
const { RangePicker } = DatePicker;

export const StyledCollapse = styled(Collapse)`
  border-radius: 8px;
  border: 1px solid ${props => props.theme.palette.background.grey2};
  background: ${props => props.theme.palette.background.primary80};
  margin: 0px 30px 30px 30px;

  .ant-collapse {
    &-item {
      border-bottom: none;

      &:last-child > .ant-collapse-content {
        border-radius: 0 0 8px 8px !important;
      }
    }

    &-header {
      display: flex;
      border-radius: 8px !important;
      align-items: center;
      text-transform: capitalize;

      .anticon {
        color: ${props => props.theme.palette.primary.main};
      }

      .ant-row {
        flex: 1;
      }
    }

    &-content {
      background: ${props => props.theme.palette.background.pearl40};
    }
  }
`;

export const APIKeyGroupName = styled(Col)`
  font-size: 18px;
  display: flex;
  align-items: center;

  .anticon {
    margin-right: 10px;
    color: ${props => props.theme.palette.warning} !important;
  }
`;

export const InlineCol = styled(Col)`
  display: flex;

  b {
    margin-right: 5px;
  }

  span {
    flex: 1;
    word-break: break-word;
  }
`;

export const FiltersContainer = styled(Row)`
  margin: 0 0px 20px 0px !important;
  background: ${props => props.theme.palette.background.pearl40};
  box-shadow:
    inset 0px -1px 0px ${props => props.theme.palette.background.pearl},
    inset 0px 1px 0px ${props => props.theme.palette.background.pearl};
  padding: 10px 30px;

  .filter-label {
    margin-bottom: 5px;
  }
`;

export const DropdownButton = styled(Button)`
  border: 1px solid ${props => props.theme.palette.border};
  border-radius: 5px;
  font-weight: normal;
  display: flex;
  align-items: center;
  padding: 0 10px;

  .anticon {
    color: ${props => props.theme.palette.primary.main};
    margin-top: 4px;
  }

  &:hover {
    border: 1px solid ${props => props.theme.palette.primary.main};
    color: ${props => props.theme.palette.text.primary};
  }

  &:active,
  &:focus {
    box-shadow: 0px 0px 2px ${props => props.theme.palette.primary.main};
    border: 1px solid ${props => props.theme.palette.primary.main};
    color: ${props => props.theme.palette.border};
  }
  .anticon-caret-down {
    color: ${props => props.theme.palette.icon.purple} !important;
    align-items: center;
    display: flex;
    font-size: 12px;
    font-style: normal;
    height: 12px;
    line-height: 1;
    margin-top: -6px;
    pointer-events: none;
    position: absolute !important;
    right: 11px;
    text-align: center;
    top: 50%;
  }
`;

export const UnstyledMenuItem = styled(Menu.Item)`
  padding: 0;

  &:hover {
    background: inherit;
    font-weight: inherit;
  }
`;

export const StyledCheckboxGroup = styled<any>(CheckboxGroup)`
  display: flex;
  flex-direction: column;
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;

  .ant-checkbox-group-item {
    padding: 7px 10px;
    width: 100%;
    height: 36px;

    &:hover {
      background: ${props => props.theme.palette.background.pearl};
    }
    &:not(.ant-checkbox-wrapper-disabled):hover,
    :not(.ant-checkbox-wrapper-disabled).ant-checkbox-wrapper-checked {
      border-color: transparent !important;
    }
  }
`;

export const StyledRangePicker = styled<any>(RangePicker)`
  height: 36px;

  &.ant-picker-focused {
    box-shadow: 0px 0px 2px ${props => props.theme.palette.primary.main};
  }
`;

export const APIKeyWarning = styled(Col)`
  width: 19px;

  .anticon {
    cursor: pointer;
    color: ${props => props.theme.palette.warning};
  }
`;

export const StatusWarning = styled.span`
  .anticon {
    color: ${props => props.theme.palette.background.purpleDarkened1};
    cursor: pointer;
    margin-left: 5px;
  }
`;

export const StyledModal = styled(Modal)`
  .ant-modal {
    &-content {
      background: ${props => props.theme.palette.background.secondary};
    }
  }
`;

export const TableButton = styled(Button)`
  border: none;
  padding: 0 2px;
  height: 28px;
  border-radius: 4px;
  background: none;
  font-size: 16px;
  color: ${props => props.theme.palette.primary.main};

  &:hover {
    color: ${props => props.theme.palette.primary.main};
    background: none;
  }

  &:active,
  &:focus {
    background: ${props => props.theme.palette.primary.main};
    color: ${props => props.theme.palette.text.light};
  }
`;

export const ActiveFiltersContainer = styled(Row)`
  border: 1px solid ${props => props.theme.palette.border};
  min-height: 40px;
  margin-top: 5px;
  border-radius: 4px;
  background: ${props => props.theme.palette.background.light};
`;

export const ActiveFiltersLabel = styled(Col)`
  background: ${props => props.theme.palette.background.pearl40};
  color: ${props => props.theme.palette.text.primary80};
  border-right: 1px solid ${props => props.theme.palette.background.grey2};
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 4px 0 0 4px;
`;

export const ActiveFilters = styled(Col)`
  flex: 1;
  padding: 3px 5px;
`;

export const RemoveFilters = styled(Col)`
  display: flex;
  align-items: center;

  button {
    border: none;
    background: none;
    cursor: pointer;
    margin-right: 5px;
  }
`;

export const StyledButton = styled(Button)`
  &.active {
    background: ${props => props.theme.palette.background.purpleDarkened3};
    border-color: ${props => props.theme.palette.background.purpleDarkened3};
    color: ${props => props.theme.palette.text.light};

    .anticon {
      color: ${props => props.theme.palette.icon.purple60};
    }
  }

  &:active,
  &:focus {
    background: ${props => props.theme.palette.background.light} !important;
    color: ${props => props.theme.palette.text.purpleDarkened3} !important;
    border-color: ${props => props.theme.palette.primary.main} !important;

    .anticon {
      color: ${props => props.theme.palette.icon.purple} !important;
    }
  }
`;

export const StyledTag = styled(Tag)`
  font-size: 14px;
  padding: 5px 7px 5px 10px;
  border-radius: 16px;
  background: ${props => props.theme.palette.icon.purple20};
  color: ${props => props.theme.palette.background.purpleDarkened3};

  .anticon {
    font-size: 14px;
    margin-left: 3px;
    opacity: 0.2;
    &:hover {
      opacity: 0.4;
    }
  }
`;
